/**
 * @module Section-Home2-About
 */

import { SectionSharedAboutContent } from "../../common/shared/about-content";
import { TypeSectionAbout, TypeSectionClients } from "../../../@types/sectionTypes";
import SectionSharedClients from "../../common/shared/clients";

/**
 * 
 * @param props : Data supplied to display About Us
 * @returns Wrapper element for about us content
 */
const SectionHome2About = (
    props: {
        _about: TypeSectionAbout,
        _clients?: TypeSectionClients
    }
) => {
    const { _about, _clients } = props;
    return (
        <div className="section-full p-t120 p-b90 site-bg-white av-about2-section-wrap wow fadeInDown" data-wow-offset={100} data-wow-delay="0.2">
            <div className="section-content">
                <div className="container">
                    <SectionSharedAboutContent _about={_about} />
                </div>
            </div>
        </div>
    )
}
export default SectionHome2About;